var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwSlambda({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 6,
    y: 6,
    fill: "#f78e05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37,36.5h-8.994L19.386,19H16v-8h8.81l8.692,18H37V36.5z M29.25,34.5H35V31h-2.752l-8.692-18H18v4 h2.63L29.25,34.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.272,36.5h-9.164l7.521-14.562l4.532,8.853L20.272,36.5z M14.392,34.5h4.65l1.875-3.703 l-2.296-4.485L14.392,34.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwSlambda);
export default __webpack_public_path__ + "static/media/AWS lambda.8cc993c3db8719f6b31d61a9da4e85dc.svg";
export { ForwardRef as ReactComponent };